
import Vue from 'vue'
import Shared from '../../shared.js'
import CreateReferee from '@/components/CreateReferee.component.vue'
import EditReferee from '@/components/EditReferee.component.vue'
export default Vue.extend({
  name: 'CompetitionPage',
  components: {
    CreateReferee,
    EditReferee
  },
  mixins: [Shared],
  data () {
    return {
      search: '',
      headers: [
        {
          text: this.$t('name'),
          sortable: true,
          value: 'name'
        },
        {
          text: this.$t('birthday'),
          sortable: true,
          value: 'birthday'
        },
        {
          text: this.$t('contact'),
          sortable: true,
          value: 'mobile'
        },
        {
          text: this.$t('gender'),
          sortable: true,
          value: 'gender'
        },
        {
          value: 'actions',
          sortable: false
        }
      ],
      editDialog: true
    }
  },
  mounted () {
    this.$store.dispatch('RefereesModule/fetchAndAdd')
  },
  methods: {
    unlink (id: string) {
      this.$store.dispatch('RefereesModule/delete', id)
    }
  }
})
